import { c as _c } from "react/compiler-runtime";
import { FB_EVENTS, sendCustomFBEvent } from 'commons/fbEvents';
import { useEffect, useMemo } from 'react';
import useMetaFormattedCityStateZip from '../useMetaFormattedCityStateZip';
const DEFAULT_BASIC_DETAILS = {};
const DEFAULT_VARIANT_SKU = '';
const useJbEventFBSelectVariation = t0 => {
  const $ = _c(10);
  const {
    basicDetails: t1,
    selectedOptionsVariantSku: t2
  } = t0;
  const basicDetails = t1 === undefined ? DEFAULT_BASIC_DETAILS : t1;
  const selectedOptionsVariantSku = t2 === undefined ? DEFAULT_VARIANT_SKU : t2;
  const {
    sku: t3,
    name: t4,
    type: t5
  } = basicDetails;
  const baseSku = t3 === undefined ? "" : t3;
  const name = t4 === undefined ? "" : t4;
  let t6;
  if ($[0] !== t5) {
    t6 = t5 === undefined ? {} : t5;
    $[0] = t5;
    $[1] = t6;
  } else {
    t6 = $[1];
  }
  const {
    name: t7
  } = t6;
  const productName = t7 === undefined ? "" : t7;
  const sku = baseSku + selectedOptionsVariantSku;
  const {
    formattedZip: zip,
    formattedCity: city,
    formattedState: state
  } = useMetaFormattedCityStateZip();
  let t8;
  let t9;
  if ($[2] !== city || $[3] !== name || $[4] !== productName || $[5] !== sku || $[6] !== state || $[7] !== zip) {
    t8 = () => {
      if (productName && sku && name) {
        window.jbEventFBSelectVariation = () => {
          sendCustomFBEvent(FB_EVENTS.SELECT_VARIATION, {
            content_category: productName,
            content_ids: [sku],
            content_name: name,
            content_type: "product",
            zp: zip,
            ct: city,
            st: state
          });
        };
      } else {
        window.jbEventFBSelectVariation = undefined;
      }
    };
    t9 = [city, name, productName, sku, state, zip];
    $[2] = city;
    $[3] = name;
    $[4] = productName;
    $[5] = sku;
    $[6] = state;
    $[7] = zip;
    $[8] = t8;
    $[9] = t9;
  } else {
    t8 = $[8];
    t9 = $[9];
  }
  useEffect(t8, t9);
};
export default useJbEventFBSelectVariation;